import React from 'react';

type Props = {
  size?: number;
};

const Divider = ({ size = 8 }: Props) => (
  <div className={`pt-${size} border-b-1 border-gray-200`} />
);

export default Divider;
